import { html } from '../../mixins/katapult-element';
import { Path } from '../../modules/Path.js';
import { KatapultEditorTemplate } from './katapult-editor-template';

class KatapultFilesEditor extends KatapultEditorTemplate {
  static get template() {
    return html` <input id="input" type="file" hidden="" multiple="multiple" on-change="inputChanged" /> `;
  }

  static get properties() {
    return {
      uploading: {
        type: Boolean,
        value: false,
        notify: true
      }
    };
  }

  createItem() {
    this.$.input.click();
  }

  async delete() {
    // Get the key for this file.
    let key = this.get('_itemData.$key');
    // Remove the file from firebase storage.
    await firebase
      .storage()
      .ref(`company_files/${this.userGroup}/${key}`)
      .delete()
      .catch((err) => {
        if (err.code != 'storage/object-not-found') throw err;
      });
    // Call editor template delete functionw which will handle removing the file record.
    await super.delete();
  }

  async download() {
    let filename = this.get('_itemData.name');
    if (this.filenameIsValid(filename)) {
      // Get the key for this file.
      let key = this.get('_itemData.$key');
      // Get download url for this file.
      let url = await firebase.storage().ref(`company_files/${this.userGroup}/${key}`).getDownloadURL();
      let blob = await fetch(url).then((res) => res.blob());
      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } else {
      throw 'Invalid Filename';
    }
  }

  filenameIsValid(filename) {
    return /^[\w,\s-]+\.[A-Za-z]+$/.test(filename);
  }

  async inputChanged(e) {
    if (this.uploading) return;
    this.uploading = true;
    let files = Array.from(this.$.input.files);
    this.$.input.value = null;
    await Promise.all(
      files.map(async (file) => {
        let key = FirebaseWorker.ref().push().key;

        // Write new file record to firebase.
        let fileRecordRef = FirebaseWorker.ref(`${this.dataPath}/${key}`);

        // Setup an onDisconnect operation to flag the file upload as having failed should we unexpectedly terminate.
        fileRecordRef.onDisconnect().update({
          status: 'failed',
          error_message: 'upload was terminated unexpectedly'
        });

        await fileRecordRef.set({
          name: file.name,
          size: file.size,
          type: file.type,
          percentage: 0,
          status: 'uploading',
          upload_date: firebase.database.ServerValue.TIMESTAMP
        });

        // Begin uploading the file to firebase storage.
        let uploadTask = firebase.storage().ref(`company_files/${this.userGroup}/${key}`).put(file);
        // Attach a state_changed callback to update the upload progress in firebase.
        uploadTask.on('state_changed', (s) => {
          let percentage = (s.bytesTransferred / s.totalBytes) * 100;
          if (!isNaN(percentage)) fileRecordRef.child('upload_progress').set(percentage);
        });

        // Wait for the upload to finish.
        let failed = false;
        await uploadTask.catch(async (err) => {
          failed = true;
          await fileRecordRef.child('error_message').set(err.message);
        });

        // Set the new status.
        await fileRecordRef.child('status').set(failed ? 'failed' : 'finished');

        // Cancel the onDisconnect operation.
        fileRecordRef.onDisconnect().cancel();
      })
    );
    // Finished uploading.
    this.uploading = false;
  }

  labelChanged(label) {
    this._labelErrorMessage = this.filenameIsValid(label) ? '' : 'You must provide a valid filename';
    this.set('_itemData.name', label);
  }

  async _saveUpdate(itemData, update, detail) {
    // Check that the new filename is valid.
    if (!detail.deleting && !this.filenameIsValid(Path.get(itemData, 'name'))) throw 'Invalid Filename';
    super._saveUpdate(...Array.from(arguments));
  }
}

customElements.define('katapult-files-editor', KatapultFilesEditor);
